type Language = 'EN' | 'FR';
type Statuses = { [key: string]: string };

export const DocStatusTranslations: { [key in Language]: Statuses } = {
    EN: {
        MISSING: 'MISSING',
        FIX_REQUIRED: 'FIX_REQUIRED',
        WAITING_FOR_APPROVAL: 'WAITING_FOR_APPROVAL',
        SIGNATURE_REQUIRED: 'SIGNATURE_REQUIRED',
        PREAPPROVED: 'PREAPPROVED',
        APPROVED: 'APPROVED',
    },
    FR: {
        MISSING: 'MANQUANT',
        FIX_REQUIRED: 'CORRECTION REQUISE',
        WAITING_FOR_APPROVAL: "EN ATTENTE D'APPROBATION",
        SIGNATURE_REQUIRED: 'SIGNATURE REQUISE',
        PREAPPROVED: 'PRÉAPPROUVÉ',
        APPROVED: 'APPROUVÉ',
    },
};

export enum DocStatus {
    MISSING = 'MISSING',
    FIX_REQUIRED = 'FIX_REQUIRED',
    WAITING_FOR_APPROVAL = 'WAITING_FOR_APPROVAL',
    SIGNATURE_REQUIRED = 'SIGNATURE_REQUIRED',
    PREAPPROVED = 'PREAPPROVED',
    APPROVED = 'APPROVED',
}

export const getTranslatedStatuses = (language: Language, statuses: Statuses): string[] => {
    return Object.values(statuses).map((status) => DocStatusTranslations[language][status]);
};
